import { Typography } from "@spz/ui/components/typography";
import { cn } from "@spz/ui/lib/utils";

export interface SectionProps {
  title: string;
  description: string;
  className?: string;
  children?: React.ReactNode;
  darken?: boolean;
}

export const Section: React.FC<SectionProps> = ({
  title,
  description,
  className,
  children,
  darken = false,
}) => (
  <div className={cn("flex flex-col", className)}>
    <div className="space-y-1">
      <Typography variant="h6" className="font-ProximaSemibold" darken={darken}>
        {title}
      </Typography>
      <Typography variant="body">{description}</Typography>
    </div>
    {children && children}
  </div>
);
